import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const FaqSection = () => {
    // State to manage which question is open
    const [openQuestion, setOpenQuestion] = useState(null);

    // Refs to manage the animation targets
    const answerRefs = useRef([]);
    answerRefs.current = [];

    // Function to add refs
    const addToRefs = (el) => {
        if (el && !answerRefs.current.includes(el)) {
            answerRefs.current.push(el);
        }
    };

    // Function to toggle the question
    const toggleQuestion = (question) => {
        setOpenQuestion(openQuestion === question ? null : question);
    };

    useEffect(() => {
        answerRefs.current.forEach((ref, index) => {
            if (openQuestion === index) {
                gsap.to(ref, { height: 'auto', opacity: 1, duration: 0.5 });
            } else {
                gsap.to(ref, { height: 0, opacity: 0, duration: 0.5 });
            }
        });
    }, [openQuestion]);

    // FAQ data
    const faqs = [
        { question: "What types of events can I book a DJ for?", answer: "DJs can be booked for a wide range of events, including weddings, private parties, corporate functions, and festivals. They can provide a musical backdrop for any occasion, from store openings to evening galas." },
        { question: "How far in advance should I book a DJ?", answer: "It’s advisable to book a DJ as early as possible, preferably several months in advance, especially for popular dates or seasons. But don’t worry if you’re in a pinch—our platform caters to last-minute bookings with ease, making it perfect for spontaneous parties or adding that extra flair to any gathering, no matter how big or small." },
        { question: "What information do I need to provide when booking a DJ?", answer: "When booking a DJ, you should provide the event date, venue location, event type, and any specific music preferences or requests." },
        { question: "Do DJs offer additional services or equipment?", answer: "Numerous DJs provide a suite of extra offerings, including lighting setups, MC duties, and the rental of audio equipment such as speakers and microphones. However, if your chosen DJ doesn’t provide these services, there’s no need to worry, we have a network of certified professionals ready to deliver alternative solutions tailored to your give location." },
        { question: "Can I request specific songs or a playlist?", answer: "Yes, most DJs are happy to accommodate specific song requests or playlists to ensure the music suits your event." },
        { question: "When should the DJ play, and for how long?", answer: "The DJ's playtime depends on your event schedule. Typically, DJs play during the reception or main event, but you can arrange the timing and duration according to your needs." },
    ];

    return (
        <div className="flex flex-col items-center gap-[64px] sm: sm:py-[96px] py-[48px] px-[24px]">

            <div className="flex flex-col items-center gap-[20px]">
                <h3 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                    Frequently asked questions
                </h3>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Everything you need to know about the product and billing.
                </span>
            </div>

            <div className="flex flex-col md:w-[768px] gap-[32px] w-full">
                {faqs.map((faq, index) => (
                    <div key={index} className="flex flex-col items-start mb-[16px] w-full">
                        <div className="flex items-start justify-between gap-[24px] w-full cursor-pointer" onClick={() => toggleQuestion(index)}>
                            <div className="flex flex-col gap-[8px]">
                                <h4 className='text-[#101828] font-[500] sm:text-[18px] text-[16px]'>
                                    {faq.question}
                                </h4>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" className='min-w-[32px]'>
                                <path d={openQuestion === index ? "M8 12H16" : "M12 8V16M8 12H16"} stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div ref={addToRefs} style={{ height: 0, overflow: 'hidden', opacity: 0 }}>
                            <p className='text-[#475467] mt-[8px]'>
                                {faq.answer}
                            </p>
                        </div>
                        <hr className='border-[#EAECF0]' />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqSection;
